import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestArFilesService } from 'src/app/service/rest/ar-files/rest-ar-files.service';
import { ARFile, ARFileBase64, } from './procedure.model';
import { environment } from 'src/environments/environment';
import { MatTableDataSource } from '@angular/material/table';

@Injectable()
export class ObjRepositoryService {

  private _arFiles: ARFile[] = [];
  private _objFiles: ARFile[] = [];
  private _imgFiles: ARFile[] = [];
  private _dataSourceObjFile: MatTableDataSource<ARFile> = new MatTableDataSource<ARFile>();
  private _dataSourceImgFile: MatTableDataSource<ARFile> = new MatTableDataSource<ARFile>();
  public  arFilesLoaded: boolean = false;

  constructor(private restArFiles: RestArFilesService) {
    if(!this.arFilesLoaded) this.loadARFiles();
  }

  public get imgFiles(): ARFile[] {
    return this._imgFiles;
  }
  public set imgFiles(value: ARFile[]) {
    this._imgFiles = value;
  }

  public get objFiles(): ARFile[] {
    return this._objFiles;
  }

  public set objFiles(value: ARFile[]) {
    this._objFiles = value;
  }

  public get arFiles(): ARFile[] {
    return this._arFiles;
  }
  public set arFiles(value: ARFile[]) {
    this._arFiles = value;
  }

  public get dataSourceImgFile(): MatTableDataSource<ARFile> {
    return this._dataSourceImgFile;
  }
  public set dataSourceImgFile(value: MatTableDataSource<ARFile>) {
    this._dataSourceImgFile = value;
  }

  public get dataSourceObjFile(): MatTableDataSource<ARFile> {
    return this._dataSourceObjFile;
  }
  public set dataSourceObjFile(value: MatTableDataSource<ARFile>) {
    this._dataSourceObjFile = value;
  }

  postFile(file: File) : Observable<any> {
    return this.restArFiles.uploadFile(file);
  }

  loadARFiles() : Observable<ARFile[]> {
    return this.restArFiles.getAllFiles();
  }

  getBase64File(id: number) : Observable<ARFileBase64> {
    return this.restArFiles.getFileBase64(id);
  }

  deleteFile(id: number): Observable<any> {
    return this.restArFiles.deleteFile(id);
  }

}
